import * as React from 'react'

import { 
  TOOL_CONNECT_BORDERED, 
  TOOL_DIAGNOSTIC_BORDERED, 
  TOOL_GRAMMAR_BORDERED, 
  TOOL_LESSONS_BORDERED, 
  TOOL_PROOFREADER_BORDERED 
} from '../asset_constants'

const LearningToWriteSlide = ({ slideGroupClassName, subheaderCopy=null, }) => (
  <section className={`slide ${slideGroupClassName} learning-to-write-slide`} key="learning-to-write-slide">
    <div>
      <h1>Learning to Write</h1>
      <p>{subheaderCopy || <React.Fragment>Quill’s tools are specifically designed to help students <b>learn to write</b> strong, grammatically correct sentences.</React.Fragment>}</p>
      <span className="divider" />
      <p>These tools include:</p>
      <ul>
        <li>
          <div className="img-wrapper">
            <img alt="" src={TOOL_DIAGNOSTIC_BORDERED} />
          </div>
          <b className="quill-red">Quill Diagnostic</b> to assess student writing and measure growth
        </li>
        <li>
          <div className="img-wrapper">
            <img alt="" src={TOOL_LESSONS_BORDERED} />
          </div>
          <b className="quill-violet">Quill Lessons</b> to lead whole-class-lessons
        </li>
        <li>
          <div className="img-wrapper">
            <img alt="" src={TOOL_CONNECT_BORDERED} />
          </div>
          <b className="quill-gold-dark">Quill Connect</b> to combine sentences using conjunctions like <i>but, because, so</i>
        </li>
        <li>
          <div className="img-wrapper">
            <img alt="" src={TOOL_PROOFREADER_BORDERED} />
          </div>
          <b className="quill-blue">Quill Proofreader</b> to edit passages
        </li>
        <li>
          <div className="img-wrapper">
            <img alt="" src={TOOL_GRAMMAR_BORDERED} />
          </div>
          <b className="quill-purple">Quill Grammar</b> to practice grammar and mechanics
        </li>
      </ul>
    </div>
  </section>
)

export default LearningToWriteSlide
